<div data-sticky-container class="sb-drag-container" id="formBuilderSticky">
    <div data-sticky data-margin-top="0" data-top-anchor="formbuilder" class="sticky">
        <button (click)="toggleAccordion('rows')" class="accordionHeader" [ngClass]="{'closed': currentlyShowingAccordion != 'rows'}">Rows</button>
		<ul cdkDropList [id]="'rowPaletteDropList'" [cdkDropListData]="rowPaletteItems" [cdkDropListEnterPredicate]="noEnter" (cdkDropListDropped)="drop($event)">			
            <li cdkDrag (cdkDragStarted)="setDragData({ type: 'row', count: 1})">
                <svg-icon icon="icon-bars" class="dark-gray" title="Add Single Question Row" unselectable="on"></svg-icon>
				<ng-template cdkDragPreview>
					<svg-icon icon="icon-bars" class="dark-gray" title="Add Single Question Row" unselectable="on"></svg-icon>
				</ng-template>
				<ng-template cdkDragPlaceholder>
					<span style="min-height: 25px">
						<svg-icon icon="icon-bars" class="dark-gray" title="Add Single Question Row" unselectable="on"></svg-icon>
					</span>
					
				</ng-template>
            </li>
            <li cdkDrag (cdkDragStarted)="setDragData({ type: 'row', count: 2})">
                <svg-icon icon="icon-th-list" class="dark-gray small" title="Add Two Question Row"></svg-icon>
				<ng-template cdkDragPreview>
					<svg-icon icon="icon-th-list" class="dark-gray small" title="Add Two Question Row"></svg-icon>
				</ng-template>
				<ng-template cdkDragPlaceholder>
					<svg-icon icon="icon-th-list" class="dark-gray small" title="Add Two Question Row"></svg-icon>
				</ng-template>
            </li>
            <li cdkDrag (cdkDragStarted)="setDragData({ type: 'row', count: 3})">
                <svg-icon icon="icon-th" class="dark-gray small" title="Add Three Question Row"></svg-icon>
				<ng-template cdkDragPreview>
					<svg-icon icon="icon-th" class="dark-gray small" title="Add Three Question Row"></svg-icon>
				</ng-template>
				<ng-template cdkDragPlaceholder>
					<svg-icon icon="icon-th" class="dark-gray small" title="Add Three Question Row"></svg-icon>
				</ng-template>
            </li>
        </ul>
        <button class="minor-margin-top accordionHeader" [ngClass]="{'closed': currentlyShowingAccordion != 'controls'}" (click)="toggleAccordion('controls')">Controls</button>
        <ul class="vertical menu" role="menubar" cdkDropList id="questionPaletteDropList" [cdkDropListData]="questionPaletteItems" [cdkDropListEnterPredicate]="noEnter" [cdkDropListConnectedTo]="svc.getInnerRowDropListIds()">
            <li cdkDrag (cdkDragStarted)="setDragData({type: 'component', value: 'label'})">
                <svg-icon icon="icon-static-text" class="dark-gray small" title="Label"></svg-icon>
            </li>
            <li cdkDrag (cdkDragStarted)="setDragData({type: 'component', value: 'textbox'})">
                <svg-icon icon="icon-text-input" class="dark-gray small" title="Textbox"></svg-icon>
            </li>
            <li cdkDrag (cdkDragStarted)="setDragData({type: 'component', value: 'phoneinput'})">
                <svg-icon icon="icon-phone" class="dark-gray small" title="Phone Input"></svg-icon>
            </li>
            <li cdkDrag (cdkDragStarted)="setDragData({type: 'component', value: 'dropdown'})">
                <svg-icon icon="icon-dropdown" class="dark-gray small" title="Dropdown"></svg-icon>
            </li>
            <li cdkDrag (cdkDragStarted)="setDragData({type: 'component', value: 'checkbox'})">
                <svg-icon icon="icon-checkbox" class="dark-gray small" title="Checkbox"></svg-icon>
            </li>
            
            <li cdkDrag (cdkDragStarted)="setDragData({type: 'component', value: 'textarea'})">
                <svg-icon icon="icon-text-area" class="dark-gray small" title="Textarea"></svg-icon>
            </li>
            <li cdkDrag (cdkDragStarted)="setDragData({type: 'component', value: 'list'})">
                <svg-icon icon="icon-list" class="dark-gray small" title="List"></svg-icon>
            </li>
            <li cdkDrag (cdkDragStarted)="setDragData({type: 'component', value: 'radio'})">
                <svg-icon icon="icon-radio-btn" class="small" title="Radio"></svg-icon>
            </li>
            <li cdkDrag (cdkDragStarted)="setDragData({type: 'component', value: 'buttonlink'})">
                <svg-icon icon="icon-btn-link" class="small" title="Button Link"></svg-icon>
            </li>
            <li cdkDrag (cdkDragStarted)="setDragData({type: 'component', value: 'yesnotoggle'})">
                <svg-icon icon="icon-yes-no" class="small" title="Yes/No Toggle"></svg-icon>
            </li>
            <li cdkDrag (cdkDragStarted)="setDragData({type: 'component', value: 'dataquerybutton'})">
                <svg-icon icon="icon-btn-query" class="small" title="Data Query Button"></svg-icon>
            </li>
            <li cdkDrag (cdkDragStarted)="setDragData({type: 'component', value: 'multiselectcheckbox'})">
                <svg-icon icon="icon-multi-select" class="small" title="Multi-Select Checkbox"></svg-icon>
            </li>
            <li cdkDrag (cdkDragStarted)="setDragData({type: 'component', value: 'esignature'})">
                <svg-icon icon="icon-signature" class="small" title="E-Signature"></svg-icon>
            </li>
            <li cdkDrag (cdkDragStarted)="setDragData({ type: 'component', value: 'chiefssignature' })">
                <svg-icon icon="icon-chief-signature" class="small" title="Chief's Signature"></svg-icon>
            </li>
            <li cdkDrag (cdkDragStarted)="setDragData({type: 'component', value: 'pdfgenerator'})">
                <svg-icon icon="icon-pdf" class="small" title="PDF Generator"></svg-icon>
            </li>
            <li cdkDrag (cdkDragStarted)="setDragData({type: 'component', value: 'pdfviewer'})">
                <svg-icon icon="icon-pdf" class="small" title="PDF Viewer"></svg-icon>
            </li>
            <li cdkDrag (cdkDragStarted)="setDragData({type: 'component', value: 'flowdatatable'})">
                <svg-icon icon="icon-data-grid" class="small" title="Data Table"></svg-icon>
            </li>
            <li cdkDrag (cdkDragStarted)="setDragData({type: 'component', value: 'casingPlanGrid'})">
                <svg-icon icon="icon-data-grid" class="small" title="Casing Plan Grid"></svg-icon>
            </li>
            <li cdkDrag (cdkDragStarted)="setDragData({type: 'component', value: 'casingPlanSchematic'})">
                <svg-icon icon="icon-image" class="small" title="Casing Plan Schematic"></svg-icon>
            </li>
            <li cdkDrag (cdkDragStarted)="setDragData({type: 'component', value: 'datepicker'})">
                <svg-icon icon="icon-calendar" class="small" title="Date Picker"></svg-icon>
            </li>
            <li cdkDrag (cdkDragStarted)="setDragData({ type: 'component', value: 'listentry'})">
                <svg-icon icon="icon-list" class="small" title="List Entry"></svg-icon>
            </li>
        </ul>
        <button class="minor-margin-top accordionHeader" [ngClass]="{'closed': currentlyShowingAccordion !== 'files'}" (click)="toggleAccordion('files')">Files</button>
        <ul class="vertical dropdown menu" role="menubar" cdkDropList id="filePaletteDropList" [cdkDropListData]="filePaletteItems" [cdkDropListEnterPredicate]="noEnter" [cdkDropListConnectedTo]="svc.getInnerRowDropListIds()">
            <li cdkDrag (cdkDragStarted)="setDragData({type: 'component', value: 'fileupload'})">
                <svg-icon icon="icon-upload" class="dark-gray small" title="File Uploader"></svg-icon>
            </li>
            <li cdkDrag (cdkDragStarted)="setDragData({ type: 'component', value: 'fileParser'})">
                <svg-icon icon="icon-report-preview" class="dark-gray small" title="File Parser"></svg-icon>
            </li>
            <li cdkDrag (cdkDragStarted)="setDragData({ type: 'component', value: 'bulkWellTransferParser' })">
                <svg-icon icon="icon-report-preview" class="dark-gray small" title="Bulk Well Transfer Parser"></svg-icon>
            </li>
        </ul>
        <button class="minor-margin-top accordionHeader" [ngClass]="{'closed': currentlyShowingAccordion !== 'maps'}" (click)="toggleAccordion('maps')">Maps</button>
        <ul class="vertical dropdown menu" role="menubar" cdkDropList id="mapPaletteDropList" [cdkDropListData]="mapPaletteItems" [cdkDropListEnterPredicate]="noEnter" [cdkDropListConnectedTo]="svc.getInnerRowDropListIds()">
            <li class="control-drag-icon-container" cdkDrag (cdkDragStarted)="setDragData({type: 'component', value: 'mapcontrol' })">
                <svg-icon icon="icon-map" class="small" title="Map"></svg-icon>
            </li>
            <li class="control-drag-icon-container" cdkDrag (cdkDragStarted)="setDragData({type: 'component', value: 'routecontrol' })">
                <svg-icon icon="icon-map-route" class="small" title="Routes"></svg-icon>
            </li>
            <li class="control-drag-icon-container" cdkDrag (cdkDragStarted)="setDragData({type: 'component', value: 'areaofreviewmap' })">
                <svg-icon icon="icon-map-area" class="small" title="Area of Review"></svg-icon>
            </li>
        </ul>
        <button class="minor-margin-top accordionHeader" [ngClass]="{'closed': currentlyShowingAccordion !== 'payments'}" (click)="toggleAccordion('payments')">Payments</button>
        <ul class="vertical dropdown menu" role="menubar" cdkDropList id="paymentPaletteDropList" [cdkDropListData]="paymentPaletteItems" [cdkDropListEnterPredicate]="noEnter" [cdkDropListConnectedTo]="svc.getInnerRowDropListIds()">
            <li class="control-drag-icon-container" cdkDrag (cdkDragStarted)="setDragData({ type: 'component', value: 'paymentCheckout'})">
                <svg-icon icon="icon-checkout" class="small" title="Payment Checkout"></svg-icon>
            </li>
            <li class="control-drag-icon-container" cdkDrag (cdkDragStarted)="setDragData({ type: 'component', value: 'paymentresponse'})">
                <svg-icon icon="icon-receipt" class="small" title="Payment Response"></svg-icon>
            </li>
        </ul>
        <button class="minor-margin-top accordionHeader" [ngClass]="{'closed': currentlyShowingAccordion != 'reports'}" (click)="toggleAccordion('reports')">Letters</button>
        <ul class="vertical dropdown menu" role="menubar" cdkDropList id="reportPaletteDropList" [cdkDropListData]="reportPaletteItems" [cdkDropListEnterPredicate]="noEnter" [cdkDropListConnectedTo]="svc.getInnerRowDropListIds()">
            <li class="control-drag-icon-container" cdkDrag (cdkDragStarted)="setDragData({type: 'component', value: 'reporttemplateselector'})">
                <svg-icon icon="icon-report-selector" class="small" title="Report Selector"></svg-icon>
            </li>
            <li class="control-drag-icon-container" cdkDrag (cdkDragStarted)="setDragData({type: 'component', value: 'reporttemplateeditor'})">
                <svg-icon icon="icon-report-editor" class="small" title="Report Editor"></svg-icon>
            </li>
            <li class="control-drag-icon-container" cdkDrag (cdkDragStarted)="setDragData({type: 'component', value: 'reportpdfview'})">
                <svg-icon icon="icon-report-preview" class="small" title="Report Preview"></svg-icon>
            </li>
            <li class="control-drag-icon-container" cdkDrag (cdkDragStarted)="setDragData({type: 'component', value: 'reportheaderimage'})">
                <svg-icon icon="icon-report-header-image" class="small" title="Report Header Image"></svg-icon>
            </li>
            <li class="control-drag-icon-container" cdkDrag (cdkDragStarted)="setDragData({type: 'component', value: 'reportheaderdefault'})">
                <svg-icon icon="icon-report-header-default" class="small" title="Report Header Default"></svg-icon>
            </li>
            <li class="control-drag-icon-container" cdkDrag (cdkDragStarted)="setDragData({type: 'component', value: 'reportfooterdefault'})">
                <svg-icon icon="icon-report-footer" class="small" title="Report Footer Default"></svg-icon>
            </li>
        </ul>
    </div>
</div>
